import React from 'react';
import PercentageGraph from './PercentageGraph';

const TagCheckBox = ({
  isFullText,
  tag,
  selectTag,
  unselectTag,
  isCheckedProp,
  isPracticeExamTag = false,
}) => {
  const toggleCheckBox = (event) => {
    if (event.target.checked) {
      selectTag(tag.id);
    } else {
      unselectTag(tag.id);
    }
  };

  return (
    <div key={tag.id} className="flex py-4">
      <input
        className="TagTreeSelector--tag_item_input mr-4 cursor-pointer"
        type="checkbox"
        onChange={toggleCheckBox}
        checked={isCheckedProp}
        id={tag.id}
      />
      <div className="flex items-center label-container">
        {isFullText ? (
          <label className="text-gray-900 font-bold font-medium">
            <div dangerouslySetInnerHTML={{ __html: tag.description }} />
          </label>
        ) : (
          <label className="text-gray-900 font-bold font-medium">
            {tag.label}
          </label>
        )}
      </div>
      {!isPracticeExamTag && (
        <div className="py-3 text-gray-600 text-14 ml-auto">
          {tag.questionByTagData.length} question
          {tag.questionByTagData.length > 1 ? 's' : ''}
        </div>
      )}
      {!isPracticeExamTag && (
        <div className="ml-auto">
          <PercentageGraph percentage={tag.percentage} />
        </div>
      )}
    </div>
  );
};

export default TagCheckBox;
